/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Component } from 'react';
import axios from 'axios';
import qs from 'qs';
import { Multiselect } from 'react-widgets';
import { RadioButton } from '../ui/BinaryRadioButton';
import Button from '../../ui/Button';
import getBase64 from '../../FileUploads';
import { showNextButton, getNextLink } from '../FormStepperFunctions';
import { selectStyles } from '../SharedFormStyles';
import withProperty from '../WithProperty';
import CurrencyField from '../../ui/CurrencyField';
import { Checkbox } from 'semantic-ui-react';
import WithDocumentStation from '../ui/DocumentStation/WithDocumentStation';
import SubmitFormButton from '../SubmitFormButton';
import withUser from 'lib/WithUser';
import { Icon, Button as SemanticButton, ButtonContent } from 'semantic-ui-react';
import ReusableTopOfForm from '../ReusableTopOfForm';
import { AutomateNames } from './Components/AutomateNames';
import { InfoFoundSection } from './Components/InfoFoundSection';
import NameSearchUploadAttachments from '../NameSearchUploadAttachments/NameSearchUploadAttachments';

const searchTypeId = 36;

class PatriotSearch extends Component {
  state = {
    nameOptions: [],
    names: [],
    attachedFiles: [],
    loaderStatus: false,
    selectAllNames: false,
    doNotCheck: false,
    searchId: 0,
    uploadAttachmentModal: true,
    documentKey: 0,
  };

  componentDidMount = async () => {
    axios
      .get(`/api/searches/GetSearchByType/${searchTypeId}/${+this.props.match.params.propertyid}`)
      .then(({ data }) => {
        this.props.setSearchId(data.id);
        this.setState({ searchId: data.id });
      });
    const queryString = qs.stringify({ searchType: 'PATRIOT / OFAC' });
    const { data: savedData } = await axios.get(
      `/api/property/GetPropertyContacts/${+this.props.match.params.propertyid}?${queryString}`
    );
    const { data } = await axios.get(
      `/api/searches/GetBankrupcyDistrict/${this.props.match.params.propertyid}`
    );
    this.setState({
      nameOptions: savedData.map(s => ({ ...s, infoFound: false })),
      district: data.district,
      names: savedData.map(s => ({ ...s, infoFound: false })),
    });
  };

  onFilesAdded = files => {
    this.setState({ attachedFiles: [...this.state.attachedFiles, ...files] });
  };

  onFileRemoved = file => {
    this.setState({
      attachedFiles: this.state.attachedFiles.filter(f => f !== file),
    });
  };

  handlePreview = async () => {
    const { data: html } = await axios.post('/api/searches/CreatePDF', {
      template: 'namesearchtemplate',
      data: await this.getFormContent(),
    });
    this.setState({ pdfHtml: html });
  };

  handleDownload = async () => {
    this.setState({ loaderStatus: true });
   
    await axios.post('/api/searches/DownloadPDF', {
      template: 'namesearchtemplate',
      data: await this.getFormContent()
    });
    const nextLink = getNextLink(
      this.props.property.orderId,
      searchTypeId,
      this.props.match.params.propertyid
    );
    if (nextLink == null) {
      this.props.history.push(`/orders/order-information/${this.props.property.orderId}`);
    } else {
      this.props.history.push(nextLink);
    }
    this.setState({ loaderStatus: false });
  };

  getFormContent = async () => {
    const { attachedFiles, names, doNotCheck } = this.state;

    const promises = attachedFiles.map(async f => {
      const base64 = await getBase64(f);
      return { name: f.name, base64String: base64 };
    });
    const files = await Promise.all(promises);
    return {
      date: new Date(),
      searchType: 'PATRIOT / OFAC',
      noText: 'No information found for Specially Designated Nationals',
      yesText: 'The following information has been found: (See attached)',
      doNotCheck,
      names,
      propertyId: +this.props.match.params.propertyid,
      searchTypeId,
      searchDocumentType: 'Patriot Attachment',
      attachments: files,
    };
  };

  handleCreate(name) {
    const { nameOptions, names } = this.state;

    const newOption = {
      name,
      id: nameOptions.length + 1,
      infoFound: false,
    };

    this.setState({
      names: [...names, newOption],
      nameOptions: [...nameOptions, newOption],
    });
  }

  render() {
    const { names, nameOptions, pdfHtml, loaderStatus, doNotCheck } = this.state;
    const showNext = showNextButton(this.props.match.params.orderId, searchTypeId);
    const params = new URLSearchParams(this.props.location.search);
    const isEdit = params.get('isEdit');
    return (
      <div css={{ display: 'flex', height: '100%' }}>
        <div css={{ width: 950 }}>
          <ReusableTopOfForm
            handlePreview={this.handlePreview}
            searchHeader="PATRIOT / OFAC Search"
            propertyId={+this.props.match.params.propertyid}
            searchTypeId={searchTypeId}
            property={this.props.property}
            getFormContent={this.getFormContent}
            template="namesearchtemplate"
            searchId={this.state.searchId}
          />
          <div css={{ marginBottom: 32 }}>
            <span
              css={{
                marginBottom: 8,
                fontWeight: 'bold',
                display: 'inline-block',
              }}
            >
              Names
            </span>
            <RadioButton
              checked={this.state.selectAllNames}
              text="Select All Names"
              addedStyles={{ marginBottom: 10 }}
              onChange={() => {
                const stateValue = !this.state.selectAllNames;
                if (stateValue) {
                  this.setState({ names: nameOptions });
                }
                this.setState({ selectAllNames: stateValue });
              }}
            />
            <div css={selectStyles}>
              <Multiselect
                value={names}
                data={nameOptions}
                onChange={editedNames => this.setState({ names: editedNames })}
                onCreate={name => this.handleCreate(name)}
                allowCreate="onFilter"
                valueField="id"
                textField="name"
                tagComponent={({ item }) => {
                  return (
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div>{item.name}</div>
                      <Icon
                        style={{ cursor: 'pointer' }}
                        name="copy outline"
                        onClick={() => {
                          navigator.clipboard.writeText(item.name);
                        }}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <Checkbox
              checked={doNotCheck}
              label={'Do not check'}
              onChange={() => this.setState({ doNotCheck: !doNotCheck })}
            />
            {this.state.names.length > 0 && (
              <NameSearchUploadAttachments
                names={names}
                open={this.state.uploadAttachmentModal}
                afterSubmit={newNames => {
                  this.setState({
                    names: newNames,
                    documentKey: this.state.documentKey + 1,
                  });
                }}
                searchId={this.state.searchId}
                searchTypeId={searchTypeId}
              />
            )}
          </div>
          {!doNotCheck && names?.length > 0 && (
            <InfoFoundSection
              headerText={'Has any information been found?'}
              names={names}
              onAllYesCheck={() => this.setState({ names: names.map(n => ({ ...n, infoFound: true })) })}
              onAllNoCheck={() => this.setState({ names: names.map(n => ({ ...n, infoFound: false })) })}
              onChangeYes={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, infoFound: true } : d)),
                })
              }
              onChangeNo={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, infoFound: false } : d)),
                })
              }
            />
          )}

          <AutomateNames
            bkDistrict={''}
            orderId={this.props.property.orderId}
            searchTypeId={searchTypeId}
            propertyId={this.props.property.id}
            searchId={this.state.searchId}
          />

          <div css={{ marginTop: 43, display: 'flex', justifyContent: 'flex-end' }}>
            <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                secondary
                onClick={() =>
                  this.props.history.push(`/orders/order-information/${this.props.property.orderId}`)
                }
                disabled={loaderStatus}
              >
                Cancel
              </Button>
              {/* <Button onClick={this.handleDownload} loadingStatus={loaderStatus}>
                  {showNext ? 'Next' : `${isEdit ? 'Save' : 'Submit'}`}
                </Button> */}
              <div css={{ marginLeft: 8 }}>
                <SubmitFormButton
                  searchTypeId={searchTypeId}
                  onSubmit={this.handleDownload}
                  reactFormal={false}
                  userId={this.props.user.id}
                  orderId={this.props.property.orderId}
                  loadingStatus={loaderStatus}
                  buttonText={showNext ? 'Next' : `${isEdit ? 'Save' : 'Submit'}`}
                  propertyId={+this.props.match.params.propertyid}
                  getFormContent={this.getFormContent}
                />
              </div>
            </div>
          </div>
          {this.state.searchId > 0 && (
            <WithDocumentStation
              key={this.state.documentKey}
              searchId={this.state.searchId}
              searchTypeId={searchTypeId}
              names={nameOptions}
            />
          )}
        </div>
        <div css={{ width: '100%' }}>
          <iframe style={{ width: '100%', height: '100%' }} srcDoc={pdfHtml} />
        </div>
      </div>
    );
  }
}

export default withUser(withProperty(PatriotSearch, searchTypeId));
